class Search {
  constructor() {
    $(window).on('load', function(){
      $('form.search-form input[id^="edit-keys"]').attr('placeholder', 'Veuillez renseigner les termes exacts à rechercher (+ de 3 caractères)');
      $('#edit-basic').append('<i class="icon-search"></i>');
      $('#edit-basic .icon-search').click(function(){
        $(this).closest('form').submit();
      });
      $('#block-fcpe-content').append($('div[role="contentinfo"]'));
    });
    $(document).ready(function(){
      let nbResults = ''
      if($('.pager').length){
        nbResults = "plus de 10";
      }
      else{
        nbResults = $("ol li").length;
      }
      $('form.search-form').prepend('<p class="infos-recherche">Votre recherche <strong>"'+ $('form.search-form input.form-search').attr('value') +'"</strong> a renvoyé '+ nbResults +' correspondance(s).');
    });
  }

  submitSearch() {
    document.querySelector('#header .search-block-form .btn-search i').addEventListener('click', function (ev) {
      if ($('#header .search-block-form, #header .search-block-form form').hasClass('on')) {
        $('form#search-block-form').submit()
      }
    });
  }

  openSearch () {
    document.querySelector('#header .search-block-form .btn-search').addEventListener('click', function (ev) {
      this.classList.toggle('on');
      $('#header .search-block-form, #header .search-block-form form').toggleClass('on')
      if ($('#header .search-block-form, #header .search-block-form form').hasClass('on')) {
        $('#header .search-block-form, #header .search-block-form form input').focus()
      }
    })
  }
}

export default Search;
